const REQUIREMENTS = [
  { id: "length", label: "Min 8 characters", test: (p) => p.length >= 8 },
  { id: "upper", label: "At least one uppercase letter (A–Z)", test: (p) => /[A-Z]/.test(p) },
  { id: "lower", label: "At least one lowercase letter (a–z)", test: (p) => /[a-z]/.test(p) },
  { id: "number", label: "At least one number (0–9)", test: (p) => /\d/.test(p) },
];

function PasswordRequirements({ password }) {
  if (!password) return null;

  return (
    <ul className="password-requirements" aria-live="polite">
      {REQUIREMENTS.map(({ id, label, test }) => {
        const met = test(password);
        return (
          <li
            key={id}
            className={`password-requirement ${met ? "met" : "unmet"}`}
          >
            <span className="password-requirement-icon" aria-hidden="true">
              {met ? "✓" : "✗"}
            </span>
            {label}
          </li>
        );
      })}
    </ul>
  );
}

export default PasswordRequirements;
